import ajax, { getDomainHostname } from "./ajax";
import { auth } from "../helpers/firebase_helper";

export function exchangePromotionCode(promotionCode) {
  return ajax("/buyer-seller-onboarding/exchange", {
    method: "POST",
    data: { promotionCode },
  });
}

export function bootstrapPromotionSession(promotionCode, storeId = null) {
  return ajax("/buyer-seller-onboarding/session/bootstrap", {
    method: "POST",
    data: { promotionCode, storeId },
  });
}

const getPromotionAuthHeaders = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error(
      "We could not resume your seller setup session. Please start again from your account."
    );
  }

  const idToken = await currentUser.getIdToken(true);
  return {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
    "domain-hostname": getDomainHostname(),
    "x-uid": currentUser.uid,
    Authorization: `Bearer ${idToken}`,
  };
};

export async function validatePromotionSession(promotionCode, storeId = null) {
  return ajax("/buyer-seller-onboarding/session", {
    method: "POST",
    data: { promotionCode, storeId },
    headers: await getPromotionAuthHeaders(),
  });
}

export async function createPromotionStore(data) {
  return ajax("/buyer-seller-onboarding/create-store", {
    method: "POST",
    data,
    headers: await getPromotionAuthHeaders(),
  });
}

export async function finalizePromotionSeller(data) {
  return ajax("/buyer-seller-onboarding/finalize", {
    method: "POST",
    data,
    headers: await getPromotionAuthHeaders(),
  });
}
